import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import LoadingDots from '../../components/common/loading/LoadingDots';
import AuthNav from '../../components/auth/AuthNav';
import Drawer from 'material-ui/Drawer';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';

function MyDrawer({loading, isLoggedIn, currentDate, me}) {

    return (
        <Drawer width={256} open={isLoggedIn}>
            <Menu style={{marginTop: 60}}>
                <MenuItem primaryText="Tableau de bord" containerElement={<Link to={'/'}/>}/>
                {me && me.is_admin && <MenuItem primaryText="Projets" containerElement={<Link to="/project"/>}/>}
                <MenuItem primaryText="Feuilles de temps" containerElement={<Link to={`/timeSheet/${currentDate}`}/>}/>
                {me && me.is_admin && <MenuItem primaryText="Utilisateurs" containerElement={<Link to={'/user'}/>}/>}
                {/*<AuthNav/>*/}
            </Menu>
            {/*loading && <LoadingDots interval={100} dots={20}/>*/}
        </Drawer>
    );
}

MyDrawer.propTypes = {
    loading: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool,
    currentDate: PropTypes.string,
    me: PropTypes.object
};

export default MyDrawer;


/** WEBPACK FOOTER **
 ** ./src/components/MyDrawer/index.js
 **/